import React from 'react'
import '../supportTabs/SupportTab.css'

const SupportTab = () => {
  return (
    <div className="tabs-detail-sec setting-tab">
      SupportTab
    </div>
  )
}

export default SupportTab
